function downloadEcoAllianceQrCertification() {
  window.open('https://assets.ctfassets.net/5gvckmvm9289/4qetmeJ7gISHnifw3fn4Ah/14ff17ab3555eb888e6adc5fcf21c775/noissue_eco_packaging_alliance_asset_pack.zip');
}
export default downloadEcoAllianceQrCertification;